// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "7f6b84c-dirty",
    "hash": "7f6b84c",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "7f6b84c-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
